import { Button } from "@mui/material"
import { Theme } from "../../../../misc/Theme"
import { store } from "../../../../stores/Store"
import { CheckIcon } from "../../../views/questionnaire/QuestionnaireTable"
import { formatValue } from "./mergeUtils"
import { Icons } from "../../../../misc/Icons"

export default function MergeConflict ({valueSources, valueToUse, fieldKey}) {
    return (
        <div style={{maxWidth: "350px", padding: "15px", display: "grid", gap: "10px"}}>
            <h3>Conflict</h3>
            
            <small>There are multiple conflicting values coming from the following sources.</small>
 
            {valueSources.map((source) => (
                <div style={{display: "grid", gridTemplateColumns: "25px auto", alignItems: "center", padding: "4px 0", gap: "4px 0px"}}>
                    <CheckIcon index={source.iconId} />
                    <small>{source.label}</small>
                    <span></span>
                    <small style={{color: Theme.palette.warning.main}}>{formatValue(fieldKey, source.value)}</small>
                    {valueToUse !== source.value ? (
                        <>
                            <span></span>
                            
                            <Button 
                                className="btn btn-xs" 
                                variant="contained" 
                                color="warning"
                                onClick={() => {
                                    store.QuestionnaireStore.setMergeOverride({
                                        ...store.QuestionnaireStore.mergeOverride,
                                        [fieldKey]: source.value
                                    })
                                }}>
                                Use this value instead
                            </Button>
                        </>
                    ) : (
                        <>
                            <span></span>
                            
                            <div style={{display: "flex", gap: "3px", alignItems: "center"}}>
                                <Icons.Info style={{fontSize: "12px"}} />
                                <small>This value is being used.</small>
                            </div>
                        </>
                    )}
                </div>
            ))}
        </div>
    )
}